// @flow

import classNames from "classnames";
import * as React from "react";

import "./Block.css";

type BlockProps = {
  children?: React.Node,
  className?: string
};

const Block = (props: BlockProps) => (
  <div className={classNames("Block", props.className)}>{props.children}</div>
);

export default Block;



// WEBPACK FOOTER //
// ./src/components/Block/Block.js